<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <!--v-row>
            <v-col cols="12">
                <v-radio-group v-model="dates.typeData" class="ma-3">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row-->

        <v-row> 
            <v-col cols="12">
                <div>
                    <v-row class="mt-2">
                        <v-col cols="6">
                            <date-filter
                                @datesSelected="setDates"
                                :search="{ typeData: dates.typeData }"
                                class="item"
                                @filtered-data="dateFilterHandler"
                                :dataToFilter="dataToGrid"
                                :filterEndpoint="$API.inventoryReports.getServicesProvidedByDoctor"
                                :isFilteredByOutsource="false"
                            />
                        </v-col>
                        
                        <v-col cols="4" v-if="dataToGrid.length > 0">
                            <br/>
                            <v-select
                                outlined
                                dense
                                attach
                                v-model="doctorSelected"
                                :items="doctorList"
                                item-text="FullName"
                                item-value="ID_User"
                                label="Filtrar por: "
                                class="fast-ease-in-transitioned-element"
                            ></v-select>
                        </v-col>
                        <v-col cols="2" v-if="dataToGrid.length > 0">
                            <br/>
                            <v-btn @click="exportToExcel" class="btn-save">Exportar a Excel</v-btn>
                        </v-col>
                    </v-row>

                    <br/>

                    <dx-pivot-grid
                        ref="pivotGrid"
                        :data-source="pivotDataSource"
                        :show-borders="true"
                        :allow-sorting-by-summary="true"
                        :allow-filtering="true"
                        :show-column-totals="true"
                        :show-row-totals="true"
                        :show-column-grand-totals="true"
                        :show-row-grand-totals="true"
                        style="max-height: 600px"
                        />
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
/*import {
  DxDataGrid,
  DxColumn,
  DxExport,
  
} from "devextreme-vue/data-grid";*/
import DxPivotGrid from 'devextreme-vue/pivot-grid';
import DateFilter from "@/components/DateFilter";
import Block from '@/components/Block.vue';
import { printToExcel } from "@/helpers/printToexcel";
import { exportPivotGrid } from "devextreme/excel_exporter";
import ExcelJS from "exceljs";
import saveAs from "file-saver";

export default {
    name: "ServicesProvidedByDoctor",
    components: {
        //DxDataGrid,
        //DxColumn,
        //DxExport,
        DateFilter,
        Block,
        DxPivotGrid,
        //DxFieldChooser
    },
    props: {
        win: {
        type: Object,
        default: () => ({}),
        },
        reportModule :{
        type: Boolean,
        default: false

        }
    },
    data() {
        return {
            tab: '01',
            loading: false,
            alignColumn: false,
            dataToGrid: [],
            dates: {
                start: null,
                end: null,
                typeData: "01",
            },
            doctorList: [
                { ID_User: "all", FullName: "Mostrar todos" }
            ],
            doctorSelected: "all"
        }
    },
    computed: {
        pivotDataSource() {
            const data = this.buildPivotData(this.dataToGrid);

            return {
                fields: [
                    { dataField: 'Fecha_Year', area: 'row', caption: 'Año', expanded: true },
                    { dataField: 'Fecha_Month', area: 'row', caption: 'Mes', expanded: true },   
                    { dataField: 'Fecha', area: 'row', dataType: 'date', groupInterval: 'day', caption: 'Fecha', expanded: true },
                    { dataField: 'TipoRegistro', area: 'row', caption: 'Tipo Registro', expanded: true },

                    { dataField: 'NombreConcatenado', area: 'column', caption: 'Doctor' },

                    {
                        dataField: 'NumAtenciones',
                        area: 'data',
                        summaryType: 'sum',
                        caption: 'Atenciones'
                    }
                ],
                store: data
            };
        }
    },
    methods: {
        imprimirDatos(e) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (e) {
                        resolve(printToExcel(e, "Reporte de servicios brindados por doctor"));
                    } else {
                        reject(`Error.`);
                    }
                }, 100);
            });
        },
        async onExporting(e) {
            this.alignColumn = true;
            await this.imprimirDatos(e);
            setTimeout(() => {
                this.alignColumn = false;
            }, 100)
        },
        setDates(dates) {
            dates.typeData = this.dates.typeData;
            this.dates = dates;
            this.loading = true;
        },
        dateFilterHandler(filteredData) {
            this.dataToGrid = filteredData.data
            this.loading = false;
        },
        getCustomCellDetail(rowData) {
            //return `${rowData.FirstName} ${rowData.LastName}`;
            return `${rowData.FullName}`
        },
        async exportToExcel() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Reporte");

            await exportPivotGrid({
            component: this.$refs.pivotGrid.instance,
            worksheet: worksheet
            });

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Reporte de servicios brindados por doctor.xlsx"
            );
        },
        buildPivotData(rawData) {
            if (this.doctorSelected == "all") {

                this.doctorList = [
                    { ID_User: "all", FullName: "Mostrar todos" }
                ]

                return rawData
                    .filter(
                        //item => item.FirstName && item.LastName
                        item => item.FullName && !item.FullName.includes("DISPONIBLE")
                    )
                    .map(item => {
                        const fecha = new Date(item.fecha + 'T00:00:00');
                        
                        this.doctorList.push({
                            //ID_User: item.ID_User_Insert,
                            //FullName: item.FirstName && item.LastName ? `${item.FirstName.trim()} ${item.LastName.trim()}` : 'SIN DOCTOR'
                            FullName: item.FullName ? `${item.FullName.trim()}` : 'SIN DOCTOR'
                        })

                        return {
                        // Fecha
                        Fecha: fecha,
                        Fecha_Year: fecha.getFullYear(),
                        Fecha_Month: fecha.toLocaleString('es-ES', { month: 'long' }),

                        // Registro
                        TipoRegistro: item.registro,

                        // Doctor (columna)
                        /*NombreConcatenado:
                            item.FirstName && item.LastName
                            ? `${item.FirstName.trim()} ${item.LastName.trim()}`
                            : 'SIN DOCTOR',*/
                        
                        NombreConcatenado: 
                            item.FullName ? `${item.FullName}` : 'SIN DOCTOR',

                        // Métrica
                        NumAtenciones: item.num_atenciones
                        };
                    });
            }
            else {
                return rawData
                    .filter(
                        //item => item.FirstName && item.LastName && item.ID_User_Insert == this.doctorSelected
                        item => item.FullName && item.FullName == this.doctorSelected
                    )
                    .map(item => {
                        const fecha = new Date(item.fecha + 'T00:00:00');
                        
                        this.doctorList.push({
                            ID_User: item.ID_User_Insert,
                            //FullName: item.FirstName && item.LastName ? `${item.FirstName.trim()} ${item.LastName.trim()}` : 'SIN DOCTOR'
                            FullName: item.FullName ? `${item.FullName.trim()}` : `SIN DOCTOR`
                        })

                        return {
                        // Fecha
                        Fecha: fecha,
                        Fecha_Year: fecha.getFullYear(),
                        Fecha_Month: fecha.toLocaleString('es-ES', { month: 'long' }),

                        // Registro
                        TipoRegistro: item.registro,

                        // Doctor (columna)
                        /*NombreConcatenado:
                            item.FirstName && item.LastName
                            ? `${item.FirstName.trim()} ${item.LastName.trim()}`
                            : 'SIN DOCTOR',*/
                        NombreConcatenado:
                            item.FullName ? `${item.FullName.trim()}` : `SIN DOCTOR`, 

                        // Métrica
                        NumAtenciones: item.num_atenciones
                        };
                    });
            }
        }
    }
}
</script>
<style scoped> 
    .background {
        background: white !important;
        color: white;
    }
    
    /* Mejoras de responsividad para el contenedor */
    .versatile-filter-container {
        width: 100%;
        overflow-x: hidden;
    }
    
    /* Media queries para dispositivos móviles */
    @media (max-width: 600px) {
        .v-radio-group {
            margin: 8px 12px !important;
        }
        
        .v-radio-group .v-radio {
            margin-bottom: 4px;
        }
        
        .v-tabs .v-tab {
            font-size: 0.875rem;
            padding: 0 8px;
        }
        
        .versatile-filter-container {
            padding: 0 4px;
        }
    }
    
    @media (max-width: 960px) and (min-width: 601px) {
        .v-radio-group {
            margin: 12px 16px !important;
        }
        
        .v-tabs .v-tab {
            font-size: 0.9rem;
        }
    }
</style>
<style>
    .dx-datagrid-rowsview .dx-row.dx-group-row td {
        text-align: left !important;
    }

    .hidden-rows .dx-datagrid-content .dx-data-row {
        display: none; /* Oculta todas las filas de datos */
    }
    
    /* Posicionar el selector de sucursal en la línea del filtro */
    .v-input--selection-controls {
        margin-top: 0 !important;
    }
    .dx-datagrid-rowsview .dx-row.dx-group-row td .dx-datagrid-summary-item {
        text-align: center !important;
    }

    .btnsave {
        background-color: #3498db !important;
        color: white;
    }

    .btn-add {
        background-color: #00a178 !important;
        color: white;
    }

</style>